exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spread[data-v-3bd18b42]{cursor:move;display:inline-block;width:calc(100% - 50px);height:25px;background-color:#666}.dragger[data-v-3bd18b42],.spread[data-v-3bd18b42]{-webkit-tap-highlight-color:transparent}.dragger[data-v-3bd18b42]{height:50%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}", ""]);

// exports
